module.exports = __webpack_public_path__ + "static/ER-model-688f86ebeb3f6adb4ff9abfe46e4195c.png";